import axios from 'axios';

const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? '/api'
  : '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
});

export const analyticsAPI = {
  // Get all trends data
  getData: async (keyword = 'Singapore PR', geo = 'SG') => {
    const response = await api.get('/data', {
      params: { keyword, geo }
    });
    return response.data;
  },

  // Get summary statistics
  getSummary: async (keyword = 'Singapore PR', geo = 'SG') => {
    const response = await api.get('/summary', {
      params: { keyword, geo }
    });
    return response.data;
  },

  // Get chart data
  getCharts: async (keyword = 'Singapore PR', geo = 'SG') => {
    const response = await api.get('/charts', {
      params: { keyword, geo }
    });
    return response.data;
  },

  // Get granular 12-month chart data (daily/weekly)
  getGranularCharts: async (keyword = 'Singapore PR', geo = 'SG') => {
    const response = await api.get('/charts/granular', {
      params: { keyword, geo }
    });
    return response.data;
  },

  // Get seasonality statistics
  getSeasonality: async (keyword = 'Singapore PR', geo = 'SG') => {
    const response = await api.get('/seasonality', {
      params: { keyword, geo }
    });
    return response.data;
  },

  // Get recent monthly changes
  getMonthlyChanges: async (keyword = 'Singapore PR', geo = 'SG') => {
    const response = await api.get('/monthly-changes', {
      params: { keyword, geo }
    });
    return response.data;
  },

  // Refresh data
  refreshData: async () => {
    const response = await api.post('/refresh');
    return response.data;
  },

  // Health check
  healthCheck: async () => {
    const response = await api.get('/health');
    return response.data;
  }
};

export default api;

// Legacy alias for backwards compatibility
export const apiClient = api;

export const zohoAPI = {
  getSummary: async () => {
    const response = await api.get('/zoho/summary');
    return response.data;
  },
  getCharts: async (period = '12m') => {
    const response = await api.get('/zoho/charts', { params: { period } });
    return response.data;
  },
  refresh: async () => {
    const response = await api.post('/zoho/refresh');
    return response.data;
  }
};

export const posthogAPI = {
  getSummary: async (days = 30) => {
    const response = await api.get('/posthog/summary', { params: { days } });
    return response.data;
  },
  getCharts: async (period = '30d') => {
    const response = await api.get('/posthog/charts', { params: { period } });
    return response.data;
  },
  refresh: async () => {
    const response = await api.post('/posthog/refresh');
    return response.data;
  }
};
